import React, {useState} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import {styledNumber} from 'app/utilities/StringHelpers/TitleHelpers';
import {setCurrentStep, isNumberAvailable} from '../changePhoneNumberSlice';
import {ChangePhoneNumberStep} from '../Constant/Constant';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import {buildUrlAndOpenWindow} from 'app/utilities/StringHelpers/StringHelpers';

const CheckoutSummary = (props) => {
  const [error, setError] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const validateAndSubmit = () => {
    setError(false);
    if (checkboxChecked) {
      //validate if number is available
      props.isNumberAvailable(props.changePhoneNumber.newSelectedNumber);
    } else {
      setError(true);
    }
  };
  const selectedType = props.changePhoneNumber.newNumbersData.find((numberType) => numberType.selected);

  return (
    <div className='checkout-summary-step step'>
      <div className='l-title'>נשאר רק לאשר את המספר</div>
      <div className='m-title'>
        לאחר החלפת המספר, לא יהיה ניתן
        <br /> להחזיר למספר הקודם
      </div>
      <div className='m-title d-flex flex-row align-items-center old-number'>
        מספר מנוי הטלפון הישן:{' '}
        <span
          className='pr-2'
          dangerouslySetInnerHTML={{__html: styledNumber(props.changePhoneNumber.selectedAccount.productSubscriberNo)}}
        />
      </div>
      <div className='new-number-data'>
        <div className='m-title mb-0'>המספר החדש שבחרת:</div>
        <div
          className='xl-title letter-spacing'
          dangerouslySetInnerHTML={{__html: styledNumber(props.changePhoneNumber.newSelectedNumber)}}
        />
        <div className='s-title link'>
          <a className='link' onClick={() => props.setCurrentStep(ChangePhoneNumberStep.SelectNewNumber)}>
            לבחירת מספר אחר{' '}
          </a>
        </div>
      </div>
      <div className='new-number-price'>
        <div>
          <span className='text'>סה״כ חיוב חד פעמי עבור {selectedType.title} </span>
          <span className='price'>
            <span className='bold letter-spacing'>{selectedType.price}</span> ₪
          </span>
        </div>
      </div>
      {/* {props.changePhoneNumber.termsLink && ( */}
      <div className='checkbox'>
        <CheckBox
          id={'checkbox-checkout-summary'}
          onCheck={() => {
            setCheckboxChecked(!checkboxChecked), setError(false);
          }}
          onUncheck={() => setCheckboxChecked(!checkboxChecked)}
          checked={checkboxChecked}
          label={
            <>
              קראתי ואני מסכים ל
              <a href='#' className='link' onClick={() => buildUrlAndOpenWindow(props.changePhoneNumber.termsLink)}>
                תנאי השירות
              </a>
            </>
          }
        />
      </div>
      {/* )} */}
      <div className='continue-button'>
        {error && <div className='error center'>כדי להמשיך יש לאשר את תנאי החבילה </div>}
        <BtnSubmit onclick={() => validateAndSubmit()} text={'בואו נחליף מספר'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
});
const mapDispatchToProps = {
  isNumberAvailable,
  setCurrentStep,
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckoutSummary);
